<template>
  <div
    v-if="numberOfUsersThatHaveResponded >= 1"
    class="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center flex-column"
  >
    <p class="mb-0 text-muted text-start">
      {{ numberOfPeople }} {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ActionListHeaderDetails',
  props: {
    action: {
      type: Object,
      default: () => {}
    },
    numberOfUsersThatHaveResponded: Number,
    numberOfUsersSelectedActions: Number,
    isFreeTextAction: Boolean
  },
  computed: {
    description() {
      if (this.isFreeTextAction) {
        return this.numberOfOtherActionsSelectedString.description
      } else {
        return this.numberOfActionsSelectedString.description
      }
    },
    numberOfPeople() {
      if (this.isFreeTextAction) {
        return this.numberOfOtherActionsSelectedString.numberOfPeople
      } else {
        return this.numberOfActionsSelectedString.numberOfPeople
      }
    },
    numberOfActionsSelectedString() {
      const str = this.$t(
        'widgetGroupActions.people',
        this.action.numberOfPeople
      )
      const [numberOfPeople, ...description] = str.split(' ')
      return { numberOfPeople, description: description.join(' ') }
    },
    numberOfOtherActionsSelectedString() {
      const str = this.$t(
        'widgetGroupActions.people',
        this.numberOfUsersSelectedActions
      )
      const [numberOfPeople, ...description] = str.split(' ')
      return { numberOfPeople, description: description.join(' ') }
    }
  },
  methods: {}
}
</script>
